/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: 1vUmEhRsA1AU
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: uyj0PXLvMOqU/component
import Container from "../../Container"; // plasmic-import: D1maE2RgYRQ-/component
import PageInfoLine from "../../PageInfoLine"; // plasmic-import: s8ByeseNVHi6/component
import Disclaimer from "../../Disclaimer"; // plasmic-import: 3Ntynz3mbk3J/component
import Footer from "../../Footer"; // plasmic-import: -uu8Ke8fb9WQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicTheIndependent.module.css"; // plasmic-import: 1vUmEhRsA1AU/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "OP team.",
    openGraph: {
      title: "OP team."
    },
    twitter: {
      card: "summary",
      title: "OP team."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicTheIndependent__VariantProps = new Array();

export const PlasmicTheIndependent__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicTheIndependent__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_cGVJnrZBpZGCmuty7FxDYj",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <div
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("all", sty.sidebar)}
          >
            <div className={classNames("all", "__wab_text", sty.text__lF4Fb)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__u4Y4U
                    )}
                    href={"https://o21p.com/"}
                    platform={"react"}
                  >
                    {"o21p"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" | "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__ewtrf
                    )}
                    href={`/old-homepage`}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__umEzb)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__cCgfB
                    )}
                    href={`/cause`}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text___0X06V)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__fbk6
                    )}
                    href={`/the-system-we-build-ourselves`}
                    platform={"react"}
                  >
                    {"our worldview"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__eYcnk)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link___5KVnV
                    )}
                    href={`/the-independent`}
                    platform={"react"}
                  >
                    {"the independent"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <section
                  data-plasmic-name={"s00"}
                  data-plasmic-override={overrides.s00}
                  className={classNames("all", sty.s00)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container___04Zub
                    )}
                    colContent={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__kpr3R
                        )}
                      >
                        {"the independent."}
                      </div>
                    }
                    width={"medium"}
                  />
                </section>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames("all", sty.s1)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container__qpicn
                    )}
                    colContent={
                      <div
                        data-plasmic-name={"freeBox"}
                        data-plasmic-override={overrides.freeBox}
                        className={classNames("all", sty.freeBox)}
                      >
                        <PageInfoLine
                          data-plasmic-name={"pageInfoLine"}
                          data-plasmic-override={overrides.pageInfoLine}
                          className={classNames(
                            "__wab_instance",
                            sty.pageInfoLine
                          )}
                          lineContent={``}
                        />

                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__b1WCj
                          )}
                        >
                          {
                            "The independent is the individual who views their work as a form of self-expression."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p___4Nwft
                          )}
                        >
                          {"They value autonomy more than comfort."}
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__dr3Ws
                          )}
                        >
                          {
                            "They care about how something is done as much as what is done."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__gSvD1
                          )}
                        >
                          {
                            "Most independents have already started building their own system around their work."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__hOQp3
                          )}
                        >
                          {
                            "They\u2019ve stepped above the pure operator role and created an outlet through which they contribute to the economy\u2014a small business, a practice, an agency, a studio, or something in between that doesn\u2019t even have a name yet."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__ocHtD
                          )}
                        >
                          {"They are not trying to escape work."}
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__tDyIh
                          )}
                        >
                          {
                            "They\u2019re trying to do work that doesn\u2019t require them to escape themselves."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__t2LEy
                          )}
                        >
                          {
                            "They push at the edges of what\u2019s possible in their field."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__fetPy
                          )}
                        >
                          {
                            "They experiment with tools, workflows, and models that give them more leverage without giving up who they are."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__ev1Ls
                          )}
                        >
                          {
                            "We like working with and building for these people."
                          }
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__sSgtQ
                          )}
                        >
                          {"We are these people."}
                        </p>
                      </div>
                    }
                    width={"medium"}
                  />
                </section>
                <section
                  data-plasmic-name={"s999"}
                  data-plasmic-override={overrides.s999}
                  className={classNames("all", sty.s999)}
                >
                  <Disclaimer
                    data-plasmic-name={"disclaimer"}
                    data-plasmic-override={overrides.disclaimer}
                    className={classNames("__wab_instance", sty.disclaimer)}
                  />

                  <Footer
                    data-plasmic-name={"footer"}
                    data-plasmic-override={overrides.footer}
                    className={classNames("__wab_instance", sty.footer)}
                    layout={"withOffset"}
                    sectionId={"footer"}
                  />
                </section>
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          <div
            data-plasmic-name={"noBudgetSmallScreens"}
            data-plasmic-override={overrides.noBudgetSmallScreens}
            className={classNames("all", sty.noBudgetSmallScreens)}
          >
            <div className={classNames("all", "__wab_text", sty.text__hDz)}>
              {"o21p"}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__nY95U)}>
              {
                "our massive development budget is dedicated to designing and building the platform for larger screens."
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__vzOcy)}>
              {"\u2013 at least 900px wide \u2013"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "sidebar",
    "pageLayout",
    "s00",
    "s1",
    "freeBox",
    "pageInfoLine",
    "s999",
    "disclaimer",
    "footer",
    "noBudgetSmallScreens"
  ],

  sidebar: ["sidebar"],
  pageLayout: [
    "pageLayout",
    "s00",
    "s1",
    "freeBox",
    "pageInfoLine",
    "s999",
    "disclaimer",
    "footer"
  ],

  s00: ["s00"],
  s1: ["s1", "freeBox", "pageInfoLine"],
  freeBox: ["freeBox", "pageInfoLine"],
  pageInfoLine: ["pageInfoLine"],
  s999: ["s999", "disclaimer", "footer"],
  disclaimer: ["disclaimer"],
  footer: ["footer"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTheIndependent__ArgProps,
          internalVariantPropNames: PlasmicTheIndependent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTheIndependent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicTheIndependent";
  } else {
    func.displayName = `PlasmicTheIndependent.${nodeName}`;
  }
  return func;
}

export const PlasmicTheIndependent = Object.assign(
  // Top-level PlasmicTheIndependent renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    pageLayout: makeNodeComponent("pageLayout"),
    s00: makeNodeComponent("s00"),
    s1: makeNodeComponent("s1"),
    freeBox: makeNodeComponent("freeBox"),
    pageInfoLine: makeNodeComponent("pageInfoLine"),
    s999: makeNodeComponent("s999"),
    disclaimer: makeNodeComponent("disclaimer"),
    footer: makeNodeComponent("footer"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicTheIndependent
    internalVariantProps: PlasmicTheIndependent__VariantProps,
    internalArgProps: PlasmicTheIndependent__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/the-independent",
      pagePath: "/the-independent",
      params: {},
      query: {}
    })
  }
);

export default PlasmicTheIndependent;
/* prettier-ignore-end */
